import { render, staticRenderFns } from "./ProfessionPageSectionPeopleSwiper.vue?vue&type=template&id=d1c352dc&scoped=true"
import script from "./ProfessionPageSectionPeopleSwiper.vue?vue&type=script&lang=js"
export * from "./ProfessionPageSectionPeopleSwiper.vue?vue&type=script&lang=js"
import style0 from "./ProfessionPageSectionPeopleSwiper.vue?vue&type=style&index=0&id=d1c352dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c352dc",
  null
  
)

export default component.exports